export const getConsultationStatusLabel = (status) => {
    if(status === "ConsultRequestCreated") return "request_created"
    if(status === "Inprogress") return "In Progress"
    return status
}